import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'

// 获取群基本信息和成员信息
export function webGetConfigByName(c_name,callback){
	request({
			method: 'post',
			url: 'config/getByName',
			data: {
				name:c_name
			}
	}).then((response)=>{
		if(response.data.code == 1){
			callback(response.data.data)
		}else{
			callback(false)
		}
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}